import { Grid } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import { IHeaderParams } from "ag-grid-community";

interface CustomHeaderProps extends IHeaderParams {
	editCallback: (colId: string) => void;
}

export const CustomHeader = (props: CustomHeaderProps) => {
	const { displayName, editCallback, column } = props;

	return (
		<Grid container alignItems="center" spacing={0}>
			<Grid item>
				<span>{displayName}</span>
			</Grid>
			<Grid item>
				<IconButton
					color="primary"
					onClick={() => editCallback(column.getColId())}
					title={`Edit ${displayName}`}
					size="medium"
				>
					<EditIcon style={{ cursor: "pointer" }} fontSize="small" />
				</IconButton>
			</Grid>
		</Grid>
	);
};
